import { IOption } from '@srm/ui/types/IOption';

export const accessTypeItems: IOption[] = [
    {
        label: 'Только мне',
        value: 'me',
    },
    {
        label: 'Всем',
        value: 'all',
    },
    {
        label: 'Подразделению',
        value: 'dep',
    },
];

/** Доступ шаблона с сервера → пункт выпадающего списка */
export const accessTypeOption = (templateAccess: string): IOption => {
    if (templateAccess === '' || templateAccess === undefined || templateAccess === null) {
        return accessTypeItems[0];
    } else if (templateAccess === '-1') {
        return accessTypeItems[1];
    } else {
        return accessTypeItems[2];
    }
};

/** Доступ шаблона в том виде, в каком его ждёт сервер */
export const templateAccessOf = (accessType?: string, deps?: string): string => {
    if (accessType === 'all') return '-1';
    if (accessType === 'dep') return deps ?? '';
    return '';
};
